import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useDocByMark } from '../../api/hooks/sales/useDocByMark';
import { Loading } from '../../components/atoms/Loading';
import { DeliveryStatusGsisDoc } from '../Delivery/component/DeliveryStatusGsisDoc';
import { SaleScreen } from './SaleScreen';

export const ViewDocByMarkScreen = () => {
  const { t } = useTranslation();
  const { mark } = useParams<{ mark: string }>();
  const { data, isLoading } = useDocByMark(mark);

  if (isLoading) return <Loading backgroundFull />;

  if (data?.success && data.data?.invoice?.id) {
    return <SaleScreen id={data.data.invoice.id} />;
  }

  if (data?.success && data.data?.doc) {
    return (
      <div className="scrollable width-100 flex-start-center-column-nowrap p-t-16 p-b-16 p-r-24 p-l-24">
        <DeliveryStatusGsisDoc doc={data.data.doc} />
      </div>
    );
  }

  return (
    <div className="scrollable width-100 flex-center-center-column-nowrap p-t-32">
      <div className="boldText4 text-center text-danger text-with-new-line max-width-900">
        {t(`API_ERRORS.${data?.errorCode}`)}
      </div>
    </div>
  );
};
